import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import emailjs from 'emailjs-com'
import AOS from "aos";
import "aos/dist/aos.css";



const ContactStyles = styled.section`
    .contact__container{
        row-gap: 3.5rem;

        .contact__content{
            .contact__title{
                display: flex;
                justify-content: center;
                align-items: center;
                column-gap: .5rem;
                font-size: var(--small-font-size);
                font-weight: var(--font-semi-bold);
                margin-bottom: 2.5rem;

                i{
                    font-size: 1rem;
                    font-weight: initial;
                }
            }
            .contact__info,.contact__form{
                display: grid;
            }
            .contact__form{
                position: relative;
                row-gap: 2rem;
                .contact__form-div{
                    position: relative;
                    height: 4rem;

                    .contact__form-tag{
                        position: absolute;
                        top: -.75rem;
                        left: 1.25rem;
                        z-index: 10;
                        background-color: var(--body-color);
                        color: var(--title-color);
                        font-size: var(--smaller-font-size);
                        font-weight: var(--font-medium);
                        padding: 0.35rem;
                        transition: background 0.4s;
                    }

                    .contact__form-input{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        border: 2px solid var(--text-color-light);
                        border-radius: 2rem;
                        padding: 1.5rem;
                        font-size: var(--normal-font-size);
                        font-family: var(--title-font);
                        color: var(--title-color);
                        background: none;
                        outline: none;
                        z-index: 1;
                    }
                }
                .contact__form-area{
                    height: 10rem;

                    textarea{
                        resize: none;
                    }
                }

                .contact__button{
                    display: flex;
                    padding: 1rem 2rem;
                    width: fit-content;
                    border: none;
                    background: none;
                    font-size: var(--h2-font-size);
                    font-family: var(--title-font);
                    font-weight: var(--font-semi-bold);
                    cursor: pointer;
                    outline: none;
                    border-radius: 1rem;
                    transition: all 0.3s;
                    color: var(--button-color);

                    i{
                        font-size: 1.5rem;
                        font-weight: initial;
                        transition: transform 0.3s;
                    }
                    &:hover{
                        background-color: var(--title-color);
                        color: var(--body-color);
                        i{
                            transform: translateX(0.3rem);
                        }
                    }

                }
                .contact__message{
                    font-size: var(--small-font-size);
                    position: absolute;
                    bottom: 3.8rem;
                    left: 1.2rem;
                }
                
            }
            .contact__info{
                row-gap: 2rem;
                .contact__data{
                    display: grid;
                    row-gap: 0.75rem;

                    .contact__data-title{
                        font-size: var(--normal-font-size);
                        color: var(--text-color-light);
                    }
                    .contact__data-info{
                        font-size: var(--normal-font-size);
                        font-family: var(--title-font);
                        color: var(--title-color);
                    }
                    .contact__button{
                        width: max-content;
                        display: inline-flex;
                        align-items: center;
                        column-gap: .5rem;
                        color: var(--title-color);
                        font-size: var(--small-font-size);

                        i{
                            font-size: 1rem;
                            transition: transform 0.3s;
                        }

                        &:hover{
                            i{
                                transform: translateX(0.25rem);
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (min-width: 767px){
        .contact__container{
            grid-template-columns: 1fr 1fr;
            padding-left: 2rem;
            padding-right: 2rem;
            justify-content: center;
            column-gap: 5rem;
        }
        .contact__form{
            width: 360px;
        }
    }
    @media screen and (min-width: 1048px){
        .container{
            margin-inline: auto;
        }
    }
    @media screen and (min-width: 1200px){
        .contact__container{
            .contact__content{
                .contact__title{
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    margin-bottom: 3rem;
                    font-size: 1.15rem;
                    i{
                        font-size: 1.25rem;
                    }
                }
                .contact__info{
                    row-gap: 3rem;
                    .contact__data{
                        .contact__data-info{
                            font-size: var(--normal-font-size);
                        }
                    }
                }
                .contact__form{
                    row-gap: 2.5rem;
                }
            }
        }
    }
`

function Contact({ menuref }) {

    const [name, setName] = useState("");
    const [mail, setMail] = useState("");
    const [message, setMessage] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_nzarp4f', 'template_x3p09cm', e.target, 'tSc75L2ePMjVNdrFe')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });

        e.target.reset();
    }

    const currref = useRef(null);

    const scrollActive = () => {
        const scrollY = window.pageYOffset;
        const sectionHeight = currref.current.offsetHeight;
        const sectionTop = currref.current.offsetTop - 58;
        // console.log(currref.current.id);
        const sectionId = currref.current.id;
        const sectionClass = menuref.current.querySelector('.nav__menu a[href*=' + sectionId + ']');

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            sectionClass.classList.add('active-link');
        } else {
            sectionClass.classList.remove('active-link');
        }

    }
    useEffect(() => {
        AOS.init({
            duration: 1000,
        });
        window.addEventListener("scroll", scrollActive);
    }, []);
    return (
        <ContactStyles className='section' id='contact' ref={currref}>
            <h2 className="section__title">Contact Me</h2>
            <span className="section__subtitle">Get in touch</span>

            <div className="contact__container container grid section__border">
                <div className="contact__content" data-aos="fade-up-right">
                    <h3 className="contact__title">
                        <i className="ri-chat-3-line"></i>Talk to me
                    </h3>

                    <div className="contact__info">
                        <div className="contact__data">
                            <span className="contact__data-title">Email</span>
                            <span className="contact__data-info">sidharts894@gmail.com</span>
                        </div>

                        <div className="contact__data">
                            <span className="contact__data-title">Linkedin</span>
                            <span className="contact__data-info">Sudhanshu894</span>

                            <a href="https://www.linkedin.com/in/Sudhanshu894" target={"_blank"} className='contact__button'>Write me
                                <i className='ri-arrow-right-line'></i>
                            </a>
                        </div>

                        <div className="contact__data">
                            <span className="contact__data-title">Github</span>
                            <span className="contact__data-info">Sudhanshu894</span>

                            <a href="https://www.github.com/sudhanshu894" target={"_blank"} className='contact__button'>Write me
                                <i className='ri-arrow-right-line'></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="contact__content" data-aos="fade-up-left">
                    <h3 className="contact__title">
                        <i className="ri-send-plane-line"></i>Write me your message
                    </h3>

                    <form action="" className="contact__form" onSubmit={sendEmail}>
                        <div className="contact__form-div">
                            <label htmlFor="" className="contact__form-tag">Name</label>
                            <input type="text" name='name' required placeholder='Write your Name' className='contact__form-input' onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div className="contact__form-div">
                            <label htmlFor="" className="contact__form-tag">Email</label>
                            <input type="email" name='email' required placeholder='Write your Email' className='contact__form-input' onChange={(e) => setMail(e.target.value)} />
                        </div>
                        <div className="contact__form-div contact__form-area">
                            <label htmlFor="" className="contact__form-tag">Message</label>
                            <textarea type="text" name='message' required placeholder='Write the message' className='contact__form-input' onChange={(e) => setMessage(e.target.value)} />
                        </div>
                        <button type='submit' className='contact__button'>
                            Submit <i className="ri-arrow-right-up-line"></i>
                        </button>
                    </form>
                </div>
            </div>
        </ContactStyles>
    )
}

export default Contact